import { api } from './api';

export const tokensService = {
  // Obtener uso de tokens de un tenant
  getTokenUsage: async (tenantId) => {
    const response = await api.get(`/tenants/${tenantId}/token-usage`);
    return response.data;
  },

  // Obtener límites de un tenant
  getLimits: async (tenantId) => {
    const response = await api.get(`/tenants/${tenantId}/limits`);
    return response.data;
  },

  // Resetear límites de un tenant
  resetLimits: async (tenantId) => {
    const response = await api.post('/limits/reset/', { tenant_id: tenantId });
    return response.data;
  },
};